/**
 * Moved to `shared/src/review/weak-serp-compare-target.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  formatWeakSerpSkipNote,
  isWeakSerpCompareTarget,
  weakSerpCompareBadgeLabel,
  weakSerpCompareReason
} from '@taptimize/shared/dist/review/weak-serp-compare-target';
export type {
  WeakSerpCompareReason
} from '@taptimize/shared/dist/review/weak-serp-compare-target';
